import { render, staticRenderFns } from "./IconKey.vue?vue&type=template&id=2f7c4b84&"
import script from "./IconKey.vue?vue&type=script&lang=js&"
export * from "./IconKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports